import { BiCheck, BiCheckDouble, BiQuestionMark, BiX } from "react-icons/bi";
import { PlacesType } from 'react-tooltip';
import './EmailAddress.scss';

export default function EmailAddress({
  email = null,
  dataTooltipPlace = 'top',
  showEmailDomainTooltip = true,
  emailDomainCount = null,
  emailVerificationStatus = null,
  emailLastVerifiedAt = null,
}: {
  email?: string | null,
  dataTooltipPlace?: PlacesType,
  showEmailDomainTooltip?: boolean,
  emailDomainCount?: number | null,
  emailVerificationStatus?: string | null,
  emailLastVerifiedAt?: string | null,
}) {
  if (typeof email !== 'string') return <></>
  const segments = (email as string).split('@')
  return <>
    <span className="email-address-container">
      {
        emailDomainCount && emailDomainCount > 0
          ? <>{ segments[0] }<span
            className="email-domain"
            data-tooltip-place={dataTooltipPlace}
            data-tooltip-hidden={!showEmailDomainTooltip}
            data-tooltip-id="main-tooltip"
            data-tooltip-content={emailDomainCount + ' emails associated with domain @' + segments[1]}
            data-tooltip-delay-show={50}
          >@{ segments[1] }</span></>
          : <>{ email }</>
      }
      {
        emailVerificationStatus === '[REDACTED]'
          ? null
          : <span className="email-verification-icon">
              {
                emailVerificationStatus === 'VALID'
                  ? <BiCheckDouble
                    fontSize={20}
                    className="email-verification-icon--valid"
                    data-tooltip-place={dataTooltipPlace}
                    data-tooltip-id="main-tooltip"
                    data-tooltip-content={`Valid email address`}
                    data-tooltip-delay-show={0}
                    />
                  : null
              }
              {
                emailVerificationStatus === 'CATCH_ALL'
                  ? <BiCheck
                    fontSize={20}
                    className="email-verification-icon--catch-all"
                    data-tooltip-place={dataTooltipPlace}
                    data-tooltip-id="main-tooltip"
                    data-tooltip-content={`Catch-all email address (any email sent to this address will be accepted)`}
                    data-tooltip-delay-show={0}
                    />
                  : null
              }
              {
                emailVerificationStatus === 'INVALID'
                  ? <BiX
                    fontSize={20}
                    className="email-verification-icon--invalid"
                    data-tooltip-place={dataTooltipPlace}
                    data-tooltip-id="main-tooltip"
                    data-tooltip-content={`Invalid email address`}
                    data-tooltip-delay-show={0}
                    />
                  : null
              }
              {
                emailVerificationStatus === 'ABUSE' || emailVerificationStatus === 'DO_NOT_MAIL'
                  ? <BiQuestionMark
                    fontSize={20}
                    className="email-verification-icon--abuse"
                    data-tooltip-place={dataTooltipPlace}
                    data-tooltip-id="main-tooltip"
                    data-tooltip-content={`Email status is '${emailVerificationStatus}'`}
                    data-tooltip-delay-show={0}
                    />
                  : null
              }
            </span>
      }
    </span>
  </>
}
